import {defaults} from '../../../../../shared/constants/defaults';
import {RegExps} from '../../../../../shared/constants/regexps';
import {ValidationItem, validationPipe} from '../../../../../shared/pipes';
import {passwordValidator, passwordValidatorMessage} from '../../../../../shared/utils/validators';

export interface PasswordCreationFormData {
  password: string;
  confirm: string;
  smsCode: string;
}

export interface PasswordCreationFormProps {
  onSubmit?: () => void;
  initialCodeProps?: string;
}

export enum PasswordCreationStep {
  RequestCode = 'requestCode',
  AwaitCode = 'awaitCode',
  EnterCode = 'enterCode',
  SetPassword = 'setPassword',
  EmailSent = 'emailSent',
}

export const getFormErrorsForPasswordCreation = (formData: PasswordCreationFormData, step: PasswordCreationStep) => {
  if (step === PasswordCreationStep.EnterCode) {
    return validationPipe(formData, [
      {
        names: 'smsCode',
        error: 'Обязательное поле',
        type: 'required',
      },
      {
        names: 'smsCode',
        error: `Код должен состоять из ${defaults.smsCodeLength} цифр`,
        type: 'pattern',
        pattern: RegExps.checkSmsCode,
      },
    ]);
  } else if (step === PasswordCreationStep.SetPassword) {
    const validationItems: ValidationItem[] = [
      {
        names: 'password',
        error: 'Обязательное поле',
        type: 'required',
      },
      {
        names: 'password',
        error: passwordValidatorMessage,
        type: 'custom',
        validator: passwordValidator,
      },
      {
        names: 'confirm',
        error: 'Обязательное поле',
        type: 'required',
      },
      {
        names: 'confirm,password',
        error: 'Поле не совпадает с паролем',
        type: 'equals',
      },
    ];
    return validationPipe(formData, validationItems);
  }
  return null;
};
